// extracted by mini-css-extract-plugin
export var textInput = "_fz-0";